import { useState } from "react";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import FinalTreatmentUnsoldTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import "./index.css";
import finalIcon from "../../../../../assets/design-revamp-company/category-icons/final-treatment-unsold-icon.svg";
const FinalTreatmentUnsoldContents = ({ businessId, category }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState(false);
  return (
    <div className="final-treatment-contents">
      <div style={{ display: "flex", alignItems: "center" }}>
        <SubHeaderBox
          subTitle={
            category === "Product Unsold Not Received"
              ? t("FINAL_TREATMENT_UNSOLD_NOT_RETURNED")
              : t("FINAL_TREATMENT_UNSOLD_RETURNED")
          }
          subDescription={
            category === "Product Unsold Not Received"
              ? t("FINAL_TREATMENT_UNSOLD_NOT_RETURNED_DESC")
              : t("FINAL_TREATMENT_UNSOLD_RETURNED_DESC")
          }
          isNormal={true}
          number={
            category === "Product Unsold Not Received" ? "18.3A" : "18.3B"
          }
          icon={finalIcon}
        />
      </div>
      {showTable && (
        <FinalTreatmentUnsoldTable
          businessId={businessId}
          category={category}
        />
      )}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default FinalTreatmentUnsoldContents;
